export const config = {
  title: 'Strive with Mo',
  meta: {
    description:
      'Strive with Mo offers personalized fitness coaching, including weight loss programs, strength training, and nutrition plans, to help you achieve your health goals.',
    keywords: [
      'Strive with Mo',
      'Personal Training',
      'Weight Loss Programs',
      'Strength Training',
      'Nutrition Plans',
      'Fitness Coaching',
      'St. Petersburg Fitness',
    ],
    author: 'Strive with Mo',
    canonicalUrl: 'https://strivexmo.com/',
  },
  sections: {
    header: {
      businessName: 'Strive with Mo',
    },
    sectionB: {
      heroTitle: 'Strive with Mo',
      heroSubtitle: 'Transform Your Life with Personalized Fitness Coaching',
      learnAboutText: 'Learn About Our Programs',
      phoneNumber: '9546085140',
      phoneLabel: '(954) 608-5140',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1173098988/photo/close-up-of-unrecognizable-woman-exercising-on-rowing-machine-in-a-gym.jpg?s=612x612&w=0&k=20&c=7KsfGHiLSHSZ7sMywd1e9rVk5AKkL0q5NFmvlAK0cEo=',
      cardData: [
        {
          title: 'Personalized Coaching',
          description:
            'Receive tailored fitness and nutrition plans designed to meet your individual goals.',
        },
        {
          title: 'Expert Guidance',
          description:
            'Work with Monisha, a NASM Certified Personal Trainer and Weight Loss Specialist, dedicated to your success.',
        },
        {
          title: 'Comprehensive Programs',
          description:
            'Access a variety of programs including weight loss, strength training, and general wellness.',
        },
      ],
      description:
        'Strive with Mo is committed to empowering individuals through customized fitness and nutrition coaching, fostering sustainable health and wellness transformations.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of personalized fitness and nutrition services designed to help you achieve your health goals.',
      cards: [
        {
          title: 'Coaching Packages',
          description:
            'Engage in one-on-one coaching with personalized workout and nutrition plans, regular check-ins, and continuous support.',
          imageSrc: 'https://strivexmo.com/wp-content/uploads/elementor/thumbs/IMG_7567-1-qoxqerk8g4giifyd4vsvoxsw7ixtyaeormj8jyq6r0.png',
          imageAlt: 'Coaching Packages',
        },
        {
          title: 'Workout Programs',
          description:
            'Choose from a variety of structured workout programs tailored to different fitness levels and goals.',
          imageSrc: 'https://strivexmo.com/wp-content/uploads/2024/05/workout-min.png',
          imageAlt: 'Workout Programs',
        },
        {
          title: 'Nutrition Plans',
          description:
            'Receive customized nutrition plans to complement your fitness regimen and promote overall health.',
          imageSrc: 'https://strivexmo.com/wp-content/uploads/2024/05/np.jpg',
          imageAlt: 'Nutrition Plans',
        },
      ],
      otherServicesTitle: 'Additional Offerings',
      otherServicesList: [
        'Beginner Weight Loss Program',
        'Intermediate & Advanced Weight Loss Program',
        'Beginner Strength Program',
        'Intermediate & Advanced Strength Program',
        'General Nutrition Guide',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://strivexmo.com/wp-content/uploads/elementor/thumbs/Tezza-3308-qov7oqmfmrjywne59t7ztdimxcw3pvgck0ggbhm4c0.jpeg',
        alt: 'Monisha - Founder of Strive with Mo',
      },
      aboutText: [
        'Strive with Mo is dedicated to empowering you to achieve lasting fitness results that enhance your life. Our philosophy emphasizes both physical and mental strength, fostering sustainable health and wellness transformations.',
        'Monisha, our founder, is a NASM Certified Personal Trainer and Weight Loss Specialist with a passion for helping individuals overcome self-doubt and achieve their fitness goals.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Strive with Mo Logo',
      businessName: 'Strive with Mo',
      contact: {
        phone: '9546085140',
        phoneLabel: '(954) 608-5140',
        email: 'mtandon123@gmail.com',
        website: 'https://strivexmo.com/',
        address: '7901 4th St N, St. Petersburg, FL 33702',
      },
      socialMedia: {
        facebook: null,
        twitter: null,
        instagram: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '7901 4th St N, St. Petersburg, FL 33702',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3520.1234567890123!2d-82.6356789!3d27.8390123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2e5abcdef1234%3A0x56789abcdef01234!2s7901%204th%20St%20N%2C%20St.%20Petersburg%2C%20FL%2033702!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus',
    },
  },
};

export default config;
